import { render, staticRenderFns } from "./statsItem.vue?vue&type=template&id=567adb62&scoped=true"
import script from "./statsItem.vue?vue&type=script&lang=js"
export * from "./statsItem.vue?vue&type=script&lang=js"
import style0 from "./statsItem.vue?vue&type=style&index=0&id=567adb62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567adb62",
  null
  
)

export default component.exports